import { LevelEnum, RaceEnum } from './nftAttribute';

export const LEGENDARY_NFT_COUNT = 8;
export const MAGIC_NFT_COUNT = 80;
export const COMMON_NFT_COUNT = 8800;

export const LEGENDARY_PRICE = 15000;
export const MAGIC_PRICE = 10000;
export const COMMON_PRICE = 500;

export const PRICE_MAP = {
  [LevelEnum.Legendary]: LEGENDARY_PRICE,
  [LevelEnum.Magic]: MAGIC_PRICE,
  [LevelEnum.Common]: COMMON_PRICE
};

export const CYBORG_NFT_COUNT = 2222;
export const PANDROID_NFT_COUNT = 2222;
export const X_GENE_NFT_COUNT = 2222;
export const AI_SPECTR_NFT_COUNT = 2222;

export const LEGENDARY_PER_RACE_NFT_COUNT = 2;
export const MAGIC_PER_RACE_NFT_COUNT = 20;
export const COMMON_PER_RACE_NFT_COUNT = 2200;

export const NFT_COUNT_MAP = {
  [LevelEnum.Legendary]: LEGENDARY_PER_RACE_NFT_COUNT,
  [LevelEnum.Magic]: MAGIC_PER_RACE_NFT_COUNT,
  [LevelEnum.Common]: COMMON_PER_RACE_NFT_COUNT
};

export const ORIGIN_SHELL_BG_COLOR: Record<RaceEnum, string> = {
  [RaceEnum.AISpectre]: '#483B18',
  [RaceEnum.Cyborg]: '#3C4A18',
  [RaceEnum.Pandroid]: '#214B19',
  [RaceEnum.XGene]: '#194B36'
};

export const ORIGIN_SHELL_THUMBNAIL: Record<RaceEnum, string> = {
  [RaceEnum.AISpectre]: '/static/images/userPage/thumbnails/AiSpectres.jpg',
  [RaceEnum.Cyborg]: '/static/images/userPage/thumbnails/Cyborg.jpg',
  [RaceEnum.XGene]: '/static/images/userPage/thumbnails/X-Gene.jpg',
  [RaceEnum.Pandroid]: '/static/images/userPage/thumbnails/Pandorid.jpg'
};
